import { Injectable } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { AppConfig } from '../app.config';
import { HttpRepo } from '../shared/services/HttpRepo';

@Injectable()
export class QbExtractorService {
    token: string;
    constructor(private appConfig: AppConfig, private httpRepo: HttpRepo) {
    }

    GetQBDetail(companyID: string) {
        return this.httpRepo.GetQbExtractorUrlWithHeaders(this.appConfig.getEndPoints().ExtractorEndpointPrefix + "/quickbooks/" + companyID + "/companyattachment", this.token);
    }
    GetSubmittedQBDetail(companyID: string) {
        return this.httpRepo.GetQbExtractorUrlWithHeaders(this.appConfig.getEndPoints().ExtractorEndpointPrefix + "/quickbooks/" + companyID + "/submitcompanyattachment", this.token);
    }
    public noWhitespaceValidator(control: FormControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'required': true };
    }
    public markFormGroupTouched(formGroup: FormGroup) {
        (<any>Object).values(formGroup.controls).forEach(control => {
            control.markAsTouched();

            if (control.controls) {
                this.markFormGroupTouched(control);
            }
        });
    }
    public GetContentFromURL(url: string) {
        return this.httpRepo.GetByAbsURL(url);
    }
}